import { Box, Button, Checkbox, CssBaseline, FormControlLabel, MenuItem, TextField } from "@mui/material";
import { callRobotApi, WifiConfig } from "./robot-api";
import { useState } from "react";
import { EditorMode } from "../RobotLandingPage";
import PageHeader from "../../components/PageHeader";
import { FlexContainer } from "../../components/FlexContainer";
import { B } from "ace-builds-internal/lib/bidiutil";
import { Refresh } from "@mui/icons-material";

export function WiFiConfig({ wifiConfig, setWifiConfig, setEditMode }: {
  wifiConfig: WifiConfig,
  setWifiConfig: (config: WifiConfig) => void, setEditMode: (mode: EditorMode) => void
}) {
  const [editWifi, setEditWifi] = useState<WifiConfig>(wifiConfig);
  const [refreshing, setRefreshing] = useState(false);
  const handleSave = async () => {
    // setWifiConfig(editWifi);
    const wifiConfig = await callRobotApi('wifi', editWifi);
    setWifiConfig(wifiConfig);
    setEditMode(EditorMode.Landing);
  };
  return (<>
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          m: 0,
          backgroundColor: "#212121",
          color: "#ECECEC",
          minHeight: "100vh",
        }}
      >
        <PageHeader
          title={"Techmage HMI / WiFi Configuration"}
          rightComponent={[]}
        />
        <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField select fullWidth label="WiFi Adapter" value={editWifi.adapter} onChange={(e) => setEditWifi({ ...editWifi, adapter: e.target.value })}>
            {editWifi.availableAdapters.map((adapter) => (
              <MenuItem key={adapter} value={adapter}>
                {adapter}
              </MenuItem>
            ))}
          </TextField>
          <FlexContainer>
            <TextField disabled={refreshing || editWifi.hotspot} select fullWidth label="WiFi SSID" value={editWifi.ssid} onChange={(e) => setEditWifi({ ...editWifi, ssid: e.target.value })}>
              {editWifi.availableSSIDs.map((ssid) => (
                <MenuItem key={ssid} value={ssid}>
                  {ssid}
                </MenuItem>
              ))}
            </TextField>
            <Button variant="contained" color="primary" sx={{ ml: 2 }} onClick={async () => {
              setRefreshing(true);
              const wifiConfig = await callRobotApi('wifi');
              setEditWifi({ ...editWifi, availableSSIDs: wifiConfig.availableSSIDs });
              setRefreshing(false);
            }}>
              <Refresh />
            </Button>
          </FlexContainer>
          <TextField disabled={refreshing || editWifi.hotspot} fullWidth label="WiFi Password" value={editWifi.password || ''} onChange={(e) => setEditWifi({ ...editWifi, password: e.target.value })} />
          <FormControlLabel
            control={<Checkbox checked={editWifi.hotspot || false} onChange={(e) => setEditWifi({ ...editWifi, hotspot: e.target.checked })} />}
            label="Enable Hotspot"
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'row' }} >
            <Button variant="contained" color="primary" onClick={() => {
              setEditMode(EditorMode.Landing);
            }}>
              Exit
            </Button>
            <Button variant="contained" color="primary" onClick={handleSave} sx={{ ml: 2 }}>
              Save WiFi Configuration
            </Button>
          </Box>
        </Box>
      </Box>
    </Box >
  </>);
}